import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus, StatusPillVariant} from "@/components/statusPill/StatusPill.types.ts";
import {IncidentState} from "@/lib/types/statuspages.ts";

const IncidentStateMap: Record<IncidentState, PillStatus> = {
  [IncidentState.INVESTIGATION]: PillStatus.INVESTIGATING,
  [IncidentState.IDENTIFIED]: PillStatus.IDENTIFIED,
  [IncidentState.MONITORING]: PillStatus.MONITORING,
  [IncidentState.RESOLVED]: PillStatus.RESOLVED,
  [IncidentState.NOTIFICATION]: PillStatus.NOTIFICATION,
  [IncidentState.MAINTENANCE]: PillStatus.MAINTENANCE,
};

interface IncidentStatePillProps {
  state: IncidentState;
  variant: StatusPillVariant;
  className?: string;
}

export const IncidentStatePill = ({state, variant, className}: IncidentStatePillProps) => {
  return <StatusPill type={"incident"} variant={variant} status={IncidentStateMap[state]} className={className} />;
};
